/**
 * The figures per month that are worked out from the API's: a month's margin
 * and its average ticket. Null when there is nothing to take them of (no
 * revenue, no paid order), so the chart leaves a gap instead of drawing a
 * made-up zero.
 *
 * @typedef {{revenue: string, profit: string, paid_orders: number}} MonthFigures
 */

/**
 * The profit as a percentage of the revenue, to one decimal.
 * @param {MonthFigures} month
 * @returns {number|null}
 */
export const marginOf = (month) => {
    const revenue = Number(month.revenue);
    return revenue > 0 ? Math.round((Number(month.profit) / revenue) * 1000) / 10 : null;
};

/**
 * What a paid order brought in on average.
 * @param {MonthFigures} month
 * @returns {number|null}
 */
export const ticketOf = (month) =>
    month.paid_orders > 0 ? Math.round((Number(month.revenue) / month.paid_orders) * 100) / 100 : null;

/**
 * The same two over a whole period: the sums of its months.
 * @param {MonthFigures[]} months
 * @returns {{margin: number|null, ticket: number|null}}
 */
export const periodFigures = (months) => {
    const revenue = months.reduce((sum, m) => sum + Number(m.revenue), 0);
    const profit = months.reduce((sum, m) => sum + Number(m.profit), 0);
    const paid = months.reduce((sum, m) => sum + m.paid_orders, 0);
    return {
        margin: revenue > 0 ? Math.round((profit / revenue) * 1000) / 10 : null,
        ticket: paid > 0 ? Math.round((revenue / paid) * 100) / 100 : null,
    };
};
